import {
	faCircleCheck as fasCircleCheck,
	faPaperPlane as fasPaperPlane,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { BasicSuccessPage } from "@component/assets/AbstractLeadForm/Steps/BasicSuccessPage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { List, ProgressButton } from "bm-ui-kit";
import compact from "lodash/compact";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export class SuccessPageSubscriptionForm extends BasicSuccessPage {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Header className="bg-green-rounded text-white">
					<div className="d-flex px-3 py-2 border-bottom">
						<div className="text-center my-auto ml-auto">
							<FontAwesomeIcon icon={fasCircleCheck} className="text-gold" size="4x" />
						</div>
						<div className="h4 mb-0 font-weight-bold text-center">
							Elküldtük neked a kölcsön részletes leírását
						</div>
					</div>
					<div className="small text-center pt-3">
						Ha addig is további kérdésed lenne, írj nekünk a{" "}
						<a className="text-reset text-underline" href="mailto:bankmonitor@bankonitor.hu">
							bankmonitor@bankonitor.hu
						</a>{" "}
						címre.
					</div>
				</Card.Header>
				{this.renderSubscribe()}
			</>
		);
	}

	protected renderSubscribe(): ReactNode {
		const { withoutSubscribe, colorVersion } = this.props;
		const { subscirbeState } = this.state;
		const isDarkVersion = colorVersion === "black";

		if (withoutSubscribe) {
			return null;
		}

		return (
			<>
				<Card.Body className="px-3 d-flex flex-column pt-2">
					<div className="h4 px-3 text-center text-uppercase text-white mt-auto">
						Ne maradj le hírlevelünkről!
					</div>
					<List itemStyle="tick" variant={isDarkVersion ? "success" : "gold"} className="mb-auto text-white">
						{this.renderSubscribeList()}
					</List>
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton
						className={`mt-2${isDarkVersion ? " font-weight-bold" : ""}`}
						variant={isDarkVersion ? "primary" : "gold"}
						icon={<FontAwesomeIcon icon={fasPaperPlane} />}
						size="lg"
						block={!!colorVersion}
						state={subscirbeState}
						onClick={this.onSubscribeClick}
					>
						Feliratkozás
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected renderSubscribeList(): ReactNode {
		return (
			<>
				<List.Item>
					<strong>Legfontosabb változások</strong> a hitel és megtakarítási lehetőségek piacán
				</List.Item>
				<List.Item>Hogyan spórolhatsz bankköltségeiden</List.Item>
				<List.Item>
					<strong>Ötletek, javaslatok</strong> hogyan hozz ki többet anyagi helyzetedből
				</List.Item>
			</>
		);
	}
	protected getClassName(): string {
		return compact([super.getClassName(), "bg-success"]).join(" ");
	}

	protected getComponentName(): string {
		return "SuccessPageSubscriptionForm";
	}
}
